import React, { FC, createContext, useEffect } from 'react';
import './index.css';

const ThemeContext = createContext<any>(null);

interface ThemeProviderProps {
  children: React.ReactNode;
  theme?: any;
}

export const ThemeProvider: FC<ThemeProviderProps> = ({ children, theme }) => {
  useEffect(() => {
    if (theme?.palette?.mode === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    }
  }, []);
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
};
